import React, { useContext } from "react";
import { withRouter } from "react-router";
import AppContext from "../../context/AppContext";
import styled from "styled-components";
import TopSection from "./TopSection";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
import Loading from "./Loading";
import DevelopmentBanner from "./DevelopmentBanner";
import AnnouncementBanner from "./AnnouncementBanner";
import environment from "../../environment";
import "../styling/styles.css";
import useLocalStorage from "../../context/useLocalStorage";

function getIsDev() {
  return environment && environment.toLowerCase() === "dev" && !window.location.href.includes("localhost");
}

const SplitWrapper = styled.div`
  display: grid;
  grid-template-columns: 312px auto;
  grid-template-rows: VAR_ROWS;
  grid-template-areas: "banner banner" "top top" "announcement announcement" "bottomLeft bottomRight";
  height: 100vh;
  overflow-y: hidden;
`;

const BottomWrapper = styled.div`
  display: grid;
  grid-template-columns: 3fr 9fr;
  grid-template-rows: VAR_ROWS;
  grid-template-areas: "banner banner" "top top" "announcement announcement" "bottom bottom";
  height: 100vh;
  overflow-y: hidden;
`;

const BottomSection = styled.div`
  grid-area: bottom;
  overflow-y: auto;
  background-color: var(--paper-grey);
`;

function MainLayout(props) {
  const context = useContext(AppContext);
  const { initialized, claims } = context;
  const ready = initialized && claims.UserType;
  const pageName = props.location.pathname.toLowerCase();
  const showLeftSection =
    !pageName ||
    pageName === "/" ||
    pageName.startsWith("/404") ||
    pageName.startsWith("/search") ||
    pageName.startsWith("/page") ||
    pageName.startsWith("/part");


  // Banner visibility logic
  const showDevBanner = environment && environment.toLowerCase() === "dev"
    && !window.location.href.includes("localhost");
  const [announcementDismissed, setAnnouncementDismissed] = useLocalStorage("dismissed.LowerShipping", false);
  const showAnnouncement = !announcementDismissed;

  // Compute grid-template-rows string
  const gridRows = `${showDevBanner ? '35px' : '0px'} 62px ${showAnnouncement ? '48px' : '0px'} auto`;

  // Styled-components hack: replace VAR_ROWS with actual value
  const SplitWrapperWithRows = React.useMemo(() => styled(SplitWrapper).attrs({})`
    grid-template-rows: ${gridRows};
  `, [gridRows]);
  const BottomWrapperWithRows = React.useMemo(() => styled(BottomWrapper).attrs({})`
    grid-template-rows: ${gridRows};
  `, [gridRows]);

  return (
    <>
      {!ready && (
        <>
          {showDevBanner && <DevelopmentBanner />}
          <TopSection location={props.location} />
          <Loading />
        </>
      )}
      {ready && showLeftSection && (
        <SplitWrapperWithRows>
          {showDevBanner && <DevelopmentBanner />}
          <TopSection location={props.location} />
          {showAnnouncement && <AnnouncementBanner onClose={() => setAnnouncementDismissed(true)} />}
          <LeftSection />
          <RightSection>{props.children}</RightSection>
        </SplitWrapperWithRows>
      )}
      {ready && !showLeftSection && (
        <BottomWrapperWithRows>
          {showDevBanner && <DevelopmentBanner />}
          <TopSection location={props.location} />
          {showAnnouncement && <AnnouncementBanner onClose={() => setAnnouncementDismissed(true)} />}
          <BottomSection location={props.location}>{props.children}</BottomSection>
        </BottomWrapperWithRows>
      )}
    </>
  );
}

export default withRouter(MainLayout);
